module.exports = __webpack_public_path__ + "static/media/new.a61ddf2b.png";